const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { margin } = attributes;

  return (
    <section className={`form-section grid ${margin}`}>
      <div className="form-section__content">
        <RichText.Content
          tagName="h2"
          className="form-section__content--title"
          value={attributes.heading}
        />
        <RichText.Content
          tagName="p"
          className="form-section__content--content"
          value={attributes.content}
        />
      </div>
      <div className="form-section__form-container">
        <h6 className="form-section__form-container__subtitle">
          ENTRE EM CONTATO
        </h6>
        {/* <form action="">
          <input className="form-section__form-container__input--large" type="text" name="name" placeholder="Digite o seu nome"/>
          <input className="form-section__form-container__input--large" type="text" name="email" placeholder="Digite o seu email"/>
          <input className="form-section__form-container__input--small" type="text" name="fone" placeholder="(99) 99999-9999"/>
          <input className="form-section__form-container__input--small" type="text" name="mobile" placeholder="(99) 99999-9999"/>
          <textarea className="form-section__form-container__textarea" name="message" id="message" cols="30" rows="10"></textarea>
          <input className="form-section__form-container__button" type="submit" value="Enviar" />
        </form> */}
        <InnerBlocks.Content />
      </div>
    </section>
  );
};
